// extracted by mini-css-extract-plugin
export default {"root":"Snackbar_root__-pBey"};